import { render } from "./Gps.vue?vue&type=template&id=c652aab6"
import script from "./Gps.vue?vue&type=script&lang=js"
export * from "./Gps.vue?vue&type=script&lang=js"
script.render = render

export default script